import { type HTMLAttributes, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export const LibraryMembersListLabel = memo(({ className, ...props }: HTMLAttributes<HTMLHeadElement>) => {
  return <h4 className={cn('font-bold text-10 text-grey-12 uppercase tracking-wide', className)} {...props} />;
});

LibraryMembersListLabel.displayName = 'LibraryMembersListLabel';
